import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface ContentModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  videoSrc?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ContentModal: React.FC<ContentModalProps> = ({
  open,
  onClose,
  title = '',
  content = '',
  videoSrc = '',
  maxWidth = 'lg',
}) => {
  const isVideo = Boolean(videoSrc);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth 
      maxWidth={maxWidth}
      PaperProps={{
        sx: isVideo ? {
          minHeight: '60vh',
        } : undefined
      }}
    >
      <DialogTitle 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          pr: 1 
        }}
      >
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        dividers
        sx={isVideo ? {
          p: 0,
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'stretch',
        } : undefined}
      >
        {content && !isVideo && (
          <Box>
            <Typography 
              variant="body1" 
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Box>
        )}
        {isVideo && (
          <Box 
            sx={{ 
              position: 'relative',
              width: '100%',
              paddingTop: '56.25%', // 16:9 aspect ratio
            }}
          >
            <iframe
              src={videoSrc}
              title={title}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ContentModal;
